import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { FaAndroid } from 'react-icons/fa';
import { LAUNCHER_APK, LAUNCHER_APK_PASSWORD, resolveLauncherEnv } from '../../lib/def/launcherApp';

/* 제타트랙 런처(APK) 다운로드 페이지.
   관리자 > 제타트랙 설정의 QR 로 들어온다. 로그인 없이 열리고, 다운로드 버튼을 누르면
   비밀번호를 확인한 뒤 서버 환경(테스트/라이브)에 맞는 APK 를 내려받는다. */

const PageWrapper = styled.div`
  min-height: 100vh;
  background: linear-gradient(180deg, #0d0d0d 0%, #1a1a2e 100%);
  color: #fff;
  display: flex;
  justify-content: center;
`;

const Content = styled.div`
  width: 100%;
  max-width: 480px;
  padding: 2.75rem 1rem 2rem;
  box-sizing: border-box;
`;

const Kicker = styled.div`
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: #e74c8a;
  margin-bottom: 0.6rem;
`;

const Title = styled.h1`
  font-size: 1.75rem;
  font-weight: 800;
  line-height: 1.35;
  margin: 0 0 0.75rem;
`;

const EnvBadge = styled.span`
  display: inline-block;
  padding: 0.25rem 0.7rem;
  border-radius: 999px;
  font-size: 0.78rem;
  font-weight: 700;
  margin-bottom: 1.75rem;
  color: ${props => props.live ? '#7ee2a8' : '#ffd479'};
  background: ${props => props.live ? 'rgba(46, 204, 113, 0.14)' : 'rgba(255, 196, 0, 0.14)'};
  border: 1px solid ${props => props.live ? 'rgba(46, 204, 113, 0.45)' : 'rgba(255, 196, 0, 0.45)'};
`;

const Card = styled.div`
  padding: 1.5rem 1.25rem;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.16);
`;

const DownloadButton = styled.button`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  padding: 1.5rem 1rem;
  border-radius: 14px;
  border: 1px solid rgba(231, 76, 138, 0.65);
  background: rgba(231, 76, 138, 0.18);
  color: #fff;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.15s, transform 0.15s;

  &:hover {
    background: rgba(231, 76, 138, 0.28);
    transform: translateY(-2px);
  }
`;

const ButtonLabel = styled.div`
  font-size: 1.05rem;
  font-weight: 700;
`;

const ButtonSub = styled.div`
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.5);
`;

const FieldLabel = styled.label`
  display: block;
  font-size: 0.9rem;
  font-weight: 700;
  margin-bottom: 0.6rem;
`;

/* 모바일 사파리는 16px 미만 입력창에 포커스가 가면 화면을 확대하므로 1rem 을 지킨다. */
const PasswordInput = styled.input`
  width: 100%;
  box-sizing: border-box;
  padding: 0.85rem 1rem;
  font-size: 1rem;
  font-family: inherit;
  letter-spacing: 4px;
  color: #fff;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid ${props => props.invalid ? 'rgba(255, 99, 99, 0.8)' : 'rgba(255, 255, 255, 0.2)'};
  border-radius: 10px;
  outline: none;

  &:focus {
    border-color: ${props => props.invalid ? 'rgba(255, 99, 99, 0.9)' : 'rgba(231, 76, 138, 0.8)'};
  }
`;

const ErrorText = styled.div`
  margin-top: 0.5rem;
  font-size: 0.82rem;
  color: #ff8a8a;
`;

const ButtonRow = styled.div`
  display: flex;
  gap: 0.6rem;
  margin-top: 1rem;
`;

const ActionButton = styled.button`
  flex: 1;
  padding: 0.85rem 1rem;
  font-size: 0.95rem;
  font-weight: 700;
  font-family: inherit;
  border-radius: 10px;
  cursor: pointer;
  color: #fff;
  border: 1px solid ${props => props.primary ? 'rgba(231, 76, 138, 0.8)' : 'rgba(255, 255, 255, 0.18)'};
  background: ${props => props.primary ? '#e74c8a' : 'rgba(255, 255, 255, 0.06)'};

  &:hover {
    opacity: 0.88;
  }
`;

const DoneText = styled.div`
  font-size: 0.95rem;
  font-weight: 700;
  line-height: 1.6;
  text-align: center;
`;

const Note = styled.div`
  margin-top: 1.25rem;
  font-size: 0.8rem;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.5);
`;

const RunningTrackLauncherDownloadPage = () => {
  const env = resolveLauncherEnv();
  const apk = LAUNCHER_APK[env];

  // ready → 다운로드 버튼, password → 비밀번호 입력, done → 다운로드 시작됨
  const [step, setStep] = useState('ready');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const inputRef = useRef(null);

  useEffect(() => {
    document.title = '제타트랙 런처 다운로드';
    const html = document.documentElement;
    const body = document.body;
    const root = document.getElementById('root');
    const prevHtmlBg = html.style.backgroundColor;
    const prevBodyBg = body.style.backgroundColor;
    const prevRootBg = root ? root.style.backgroundColor : '';
    const prevRootPadding = root ? root.style.paddingBottom : '';

    html.style.backgroundColor = '#0d0d0d';
    body.style.backgroundColor = '#0d0d0d';
    if (root) {
      root.style.backgroundColor = '#0d0d0d';
      // index.css 의 전역 `#root { padding-bottom: 8rem }` 을 이 페이지에서만 걷어낸다.
      root.style.paddingBottom = '0';
    }

    return () => {
      html.style.backgroundColor = prevHtmlBg;
      body.style.backgroundColor = prevBodyBg;
      if (root) {
        root.style.backgroundColor = prevRootBg;
        root.style.paddingBottom = prevRootPadding;
      }
    };
  }, []);

  useEffect(() => {
    if (step === 'password' && inputRef.current) inputRef.current.focus();
  }, [step]);

  //--> 교차 출처라 <a download> 는 무시된다. 주소로 이동하면 스토리지가 APK 로 내려준다.
  const startDownload = () => {
    window.location.href = apk.url;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password !== LAUNCHER_APK_PASSWORD) {
      setError('비밀번호가 올바르지 않습니다.');
      setPassword('');
      if (inputRef.current) inputRef.current.focus();
      return;
    }
    setError('');
    setStep('done');
    startDownload();
  };

  const handleCancel = () => {
    setStep('ready');
    setPassword('');
    setError('');
  };

  return (
    <PageWrapper>
      <Content>
        <Kicker>JetaTrack Launcher</Kicker>
        <Title>제타트랙 런처 다운로드</Title>
        <EnvBadge live={env === 'live'}>{apk.label} 서버</EnvBadge>

        {step === 'ready' && (
          <DownloadButton type="button" onClick={() => setStep('password')}>
            <FaAndroid size={36} />
            <ButtonLabel>APK 다운로드</ButtonLabel>
            <ButtonSub>최신 버전 (.apk)</ButtonSub>
          </DownloadButton>
        )}

        {step === 'password' && (
          <Card>
            <form onSubmit={handleSubmit}>
              <FieldLabel htmlFor="launcher-apk-password">다운로드 비밀번호</FieldLabel>
              <PasswordInput
                id="launcher-apk-password"
                ref={inputRef}
                type="password"
                inputMode="numeric"
                autoComplete="off"
                maxLength={20}
                value={password}
                invalid={!!error}
                onChange={(e) => { setPassword(e.target.value); if (error) setError(''); }}
              />
              {error && <ErrorText>{error}</ErrorText>}
              <ButtonRow>
                <ActionButton type="button" onClick={handleCancel}>취소</ActionButton>
                <ActionButton type="submit" primary>다운로드</ActionButton>
              </ButtonRow>
            </form>
          </Card>
        )}

        {step === 'done' && (
          <Card>
            <DoneText>다운로드가 시작됩니다.</DoneText>
            <ButtonRow>
              <ActionButton type="button" onClick={startDownload}>다시 받기</ActionButton>
            </ButtonRow>
          </Card>
        )}

        <Note>
          설치할 때 «출처를 알 수 없는 앱» 설치를 허용해야 할 수 있습니다.
        </Note>
      </Content>
    </PageWrapper>
  );
};

export default RunningTrackLauncherDownloadPage;
